import { render, staticRenderFns } from "./CatalogueList.vue?vue&type=template&id=16a1fc71&scoped=true"
import script from "./CatalogueList.vue?vue&type=script&lang=js"
export * from "./CatalogueList.vue?vue&type=script&lang=js"
import style0 from "./CatalogueList.vue?vue&type=style&index=0&id=16a1fc71&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a1fc71",
  null
  
)

export default component.exports